<div
  class="h-full"
  *appHasPermission="{
    permissions: [permissions.allPermissions.SYSTEM_ALERT_READ],
  }"
>
  <div class="widget">
    <div class="list-compact-rows">
      <div class="flex justify-content-between align-items-center">
        <span class="listTitle">
          {{ "system_alerts.list_title" | translate }}
        </span>
        <app-svg-icon (click)="onSystemAlertAdd()" iconName="plus" iconColor="primary" class="pointer" iconSize="xs">
          <!-- *appHasPermission="{
            permissions: [permissions.allPermissions.SYSTEM_ALERT_CREATE],
          }" -->
        </app-svg-icon>
      </div>
      <ngx-simplebar [options]="{ autoHide: false }" class="listItems">
        @for (systemAlert of systemAlerts(); track systemAlert.id) {
          <div class="listRow">
            <span>{{ systemAlert.message }}</span>
            <div class="actionButtonGroup">
              <app-svg-icon
                (click)="onSystemAlertEdit(systemAlert)"
                iconName="edit"
                iconColor="primary"
                class="pointer"
                iconSize="xs"
              >
                <!-- *appHasPermission="{
                    permissions: [
                      permissions.allPermissions.SYSTEM_ALERT_UPDATE,
                    ],
                  }" -->
              </app-svg-icon>
              <app-svg-icon
                (click)="onSystemAlertDelete($event, systemAlert)"
                iconName="trash"
                iconColor="primary"
                class="pointer"
                iconSize="xs"
              >
                <!-- *appHasPermission="{
                    permissions: [
                      permissions.allPermissions.SYSTEM_ALERT_DELETE,
                    ],
                  }" -->
              </app-svg-icon>
            </div>
          </div>
        }
      </ngx-simplebar>
    </div>
  </div>
</div>
